<app-dialog
	modalTitle="Novo beneficiário"
	titleButton="Continuar"
	secTitleButton="Cancelar"
	[secButton]="true"
	[hideFooter]="false"
	[disabled]="selected === 0"
	[noMargins]="true"
	(dialogClose)="closeModal()"
	(dialogSave)="onContinue()"
>
	<div class="d-f fd-c ai-c w-100 h-100">
		<p class="mt-md mb-md fs-xs gray">Selecione quem deseja cadastrar</p>
		<div class="d-f jc-sa ai-c w-100">
			<div
				class="d-f fd-c ai-c jc-c br-md c-p card {{
					selected === 1 ? 'bold-border' : ''
				}}"
				(click)="selected = 1"
			>
				<img src="../../../../../../assets/images/titular.svg" alt="titular" />
				<p class="mt-sm fs-sm fw-bold card-label">Titular</p>
			</div>
			<div
				class="d-f fd-c ai-c jc-c br-md c-p card {{
					selected === 2 ? 'bold-border' : ''
				}}"
				(click)="selected = 2"
			>
				<img
					src="../../../../../../assets/images/dependente.svg"
					alt="dependente"
				/>
				<p class="mt-sm fs-sm fw-bold card-label">Dependente</p>
			</div>
		</div>
		<p class="mt-md ml-sm mr-sm fs-xs gray">
			Ao cadastrar um novo titular você poderá incluir os dependentes no mesmo
			momento, ou cadastrá-los depois.
		</p>
	</div>
</app-dialog>
